<script>
import { Tag } from 'ant-design-vue';

export default {
  emits: ['onClose'],
  components: { Tag },
  props: {
    color: {
      type: String,
      default: 'orange',
    },
    closable: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <Tag :color="color" :closable="closable" @close="() => $emit('onClose')">
    <slot />
  </Tag>
</template>

<style lang="scss" scoped></style>
